<template>
  <Card class="widget-height-md ivu-card-custom" shadow>
    <div slot="title" class="with-icon">
      <h4>
        <table width="100%" border="0">
          <tr>
            <td style="width: 2%;" align="left">
              <Icon type="ios-arrow-back" color="white" size="24" title="Back to Leads Processed"
                    @click.native="goBackToGlobalAdmin"/>
            </td>
            <td style="width: 96%" align="left">
              <span>Users for <strong>{{this.companyName}}</strong></span>
            </td>
          </tr>
        </table>
      </h4>
      <Icon type="ios-add-circle-outline" size="24"
            @click.native="$refs.userForm.openUserForm('ADD USER','add')"/>
    </div>
    <div class="widget-data full-height">
      <Table :columns="dataColumns" :data="items" class="full-height show-borders initial-height"
             stripe border shadow></Table>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>

    <UserForm ref="userForm" @addNewUser="addNewUser" @updateUser="updateUser"></UserForm>
    <Modal v-model="confirmDelete" title="CONFIRMATION" @on-ok="removeUser(currentDeleteIndex)"
           ok-text="Continue"
           class-name="vertical-center-modal card-modal" :width="480">
      <div class="confirmation-body">
        <p>
          <Icon type="md-help-circle" size="24" color="#f90"/>
          <span>{{confirmDeleteMessage}}</span>
        </p>
        <br>
        <Icon type="ios-checkmark-circle-outline" v-on:click="softDelete = !softDelete"
              :class="[!softDelete ? 'hardDelete' : 'check']"/>
        <span style="font-size: 11pt">Hard delete</span>
        <p v-show="!softDelete" class="submessage"><b>Warning:</b> You are about to delete the user permanently. All
          associated data will also be erased.</p>
        <p v-show="softDelete" class="submessage"><b>Warning:</b> All associated data will be hidden.</p>
      </div>
      <div slot="footer">
        <Button size="large" @click="confirmDelete=false">Cancel</Button>
        <Button size="large" class="submit" type="error"
                @click="removeUser(currentDeleteIndex);confirmDelete=false">Delete
        </Button>
      </div>
    </Modal>
  </Card>
</template>
<script>
  import UserForm from './UserForm.vue'
  import {deleteUser, getUsersByCompanyId} from '../../services/User.service'
  import {bus} from '../../main'

  export default {
    components: {
      UserForm
    },
    props: ['users'],
    data() {
      return {
        companyId: null,
        companyName: null,
        spinShow: true,
        confirmDelete: false,
        confirmDeleteMessage: '',
        currentDeleteIndex: null,
        dataColumns: [
          {
            title: 'First Name',
            key: 'firstName',
            align: 'left',
            minWidth: 120,
            maxWidth: 120,
            className: 'paddingIndent',
            sortable: true
          },
          {
            title: 'Last Name',
            key: 'lastName',
            minWidth: 120,
            maxWidth: 120,
            align: 'left',
            sortable: true
          },
          {
            title: 'Email',
            key: 'email',
            align: 'left',
            minWidth: 120,
            maxWidth: 120,
            sortable: true
          },
          {
            title: 'Cellphone',
            key: 'phone',
            align: 'left',
            minWidth: 100,
            maxWidth: 100,
            sortable: true
          },
          {
            title: 'Actions',
            key: 'action',
            align: 'left',
            minWidth: 80,
            maxWidth: 80,
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-create-outline',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.$refs.userForm.openUserForm('UPDATE USER', 'edit');
                      this.$refs.userForm.setFormValue(params.row, params.index)
                    }
                  }
                }, 'edit'),
                h('Icon', {
                  props: {
                    type: 'ios-close-circle-outline',
                    color: '#9b3035',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.confirmDeleteMessage = `Are you sure you want to delete user "${params.row.firstName} ${params.row.lastName}"?`
                      this.confirmDelete = true
                      this.currentDeleteIndex = params.index;
                    }
                  }
                }, 'delete')
              ]);
            }
          }
        ],
        items: [],
        userObj: {
          userId: null,
          userRoleId: null,
          companyId: null,
          managerId: null,
          userName: null,
          password: null,
          firstName: null,
          middleName: null,
          lastName: null,
          address: null,
          city: null,
          country: null,
          email: null,
          phone: null,
          createdBy: null,
          createdDate: null,
          deleted: null,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          eventIds: null,
        },
        softDelete: true,
      }
    },
    watch: {
      users(users) {
        this.setTableData(users)
      },
    },
    computed: {
      // hardDelete: function() {
      //   return {
      //     bColor: this.softDelete
      //   }
      // }
    },
    methods: {
      setTableData(users) {
        this.items = users;
        this.spinShow = false;
      },
      getListUsers(companyId) {
        const self = this;
        if (companyId > 0) {
          getUsersByCompanyId(companyId).then(response => {
            self.items = response.data;
            self.spinShow = false;
          });
        } else {
          self.items = [];
          self.spinShow = false;
        }
      },
      showSpin() {
        this.spinShow = true;
      },
      addNewUser(data) {
        this.items.push(data);
      },
      updateUser(id, data) {
        let itemIndex = this.items.map(i => {
          return i.userId;
        }).indexOf(id);
        this.items.splice(itemIndex, 1, data);
      },
      removeUser(index) {
        deleteUser(this.items[index].userId, !this.softDelete).then(response => {
          this.items.splice(index, 1);
          this.$Message.success('User successfully deleted!');
          bus.$emit('reloadUsers', (this.items[index].companyId));
        }).catch(error => {
          this.$Message.error('Failed deleting user');
        })
      },
      goBackToGlobalAdmin() {
        bus.$emit('getActiveLink', 'GlobalAdministration');
      },
    },
    created() {
      this.showSpin();
      this.companyId = localStorage.getItem('selected_company_users');
      this.companyName = JSON.parse(localStorage.getItem('companies'))
        .filter(a => a.companyId == this.companyId)[0].companyName;
      this.getListUsers(this.companyId);
    },
    mounted() {
      bus.$on('reloadUsers', (companyId) => {
        this.getListUsers(companyId);
      });
    }
  }
</script>
<style scoped>
  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }

  .ivu-table table tbody tr td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table td {
    height: 80px;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

  .ivu-table-cell td, .ivu-table-cell th {
    border: 0;
    height: 20px;
    line-height: 1;
  }

  .hardDelete {
    background-color: red;
    border-radius: 15px;
    font-size: 14pt;
  }

  .check {
    font-size: 14pt;
    background-color: transparent;
    border-radius: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/i_users/Users.vue